import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { MAIN_CONTENT_ID } from "@/constants/a11y";
import { isAccountRoutePath } from "@/constants/navigation";

export function useRouteChangeFocus(): void {
  const {
    hash,
    key,
    pathname,
  } = useLocation();
  const previousLocationRef = useRef({
    key,
    pathname,
  });

  useEffect(() => {
    const previousLocation = previousLocationRef.current;
    previousLocationRef.current = {
      key,
      pathname,
    };

    if (previousLocation.key === key) {
      return;
    }

    if (hash) return;

    if (
      isAccountRoutePath(previousLocation.pathname)
      && isAccountRoutePath(pathname)
    ) {
      return;
    }

    const frame = window.requestAnimationFrame(() => {
      window.scrollTo({ behavior: "auto", left: 0, top: 0 });
      document.getElementById(MAIN_CONTENT_ID)?.focus({ preventScroll: true });
    });

    return () => {
      window.cancelAnimationFrame(frame);
    };
  }, [hash, key, pathname]);
}
